import React, { Fragment } from "react";
import { motion } from "framer-motion";
import Header from "../../components/header/Header";
import Hero2 from "../../components/hero2/hero2";
import About2 from "../../components/about2/about2";
import AboutTab from "../TaniltsuulgaPage/AboutTab";
import Suuliin2Medee from "../../components/Suuliin2Medee/Suuliin2Medee";
// import Testimonial2 from "../../components/Testimonial2/Testimonial2";
// import StoriesSection2 from "../../components/StoriesSection2/StoriesSection2";
// import Missionvision from "../../components/MissionVision/MissionVision";
// import Testimonial3 from "../../components/Testimonial3/Testimonial3";

import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";

const HomePage2 = ({ isDark, onToggleDark }) => {
  return (
    <Fragment>
      <motion.div
        intial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <div>
          <Header isDark={isDark} hclass={"header--styleThree"} />
          <main className="page_content">
            <Hero2 isDark={isDark} />
            <AboutTab />
            <About2 />
            {/* <Testimonial3 />  */}
            <Suuliin2Medee />
            {/* <Missionvision /> */}
          </main>
          <Footer isDark={isDark} onToggleDark={onToggleDark} />
          <Scrollbar />
        </div>
      </motion.div>
    </Fragment>
  );
};
export default HomePage2;
